import { render, staticRenderFns } from "./AthleteSettingsPaymentForm.vue?vue&type=template&id=eee4ddc0&scoped=true&"
import script from "./AthleteSettingsPaymentForm.vue?vue&type=script&lang=ts&"
export * from "./AthleteSettingsPaymentForm.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteSettingsPaymentForm.vue?vue&type=style&index=0&id=eee4ddc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee4ddc0",
  null
  
)

export default component.exports